import { TIMER, Gameplay } from "../Gameplay";

/**
 * Odberne misto pro baliky
 */
export class DeliveryPoint {
    /**
     * (RO) Pozice v hernim svete na ose Z
     */
    get worldPos(): number { return this._worldPos; }
    private _worldPos: number;

    /**
     * (RO) Smer, kterym se balicek predava po ose Z (1 = smerem dolu, -1 = smerem nahoru)
     */
    get dir(): number { return this._dir; }
    private _dir: number;

    private _vanEntity: pc.Entity;

    private static readonly ANIM_SCALE_ADD = 0.4;

    private _animState: number;
    private _animTime: number;

    //-------------------------------------------------------------------------
    /**
     * Konstruktor
     * @param worldPos Pozice v hernim svete
     * @param dir Smer, kterym se balicek predava po ose Z (1 = smerem dolu, -1 = smerem nahoru)
     */
    //-------------------------------------------------------------------------
    constructor(vanEntity: pc.Entity, worldPos: number, dir: number) {
        this._vanEntity = vanEntity;
        this._worldPos = worldPos;
        this._dir = dir;
        this._animState = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._animState = 0;
        this._vanEntity.setLocalScale(1, 1, 1);
    }

    //-------------------------------------------------------------------------
    /**
     * Zobrazit efekt pro doruceni balicku
     */
    //-------------------------------------------------------------------------
    showDeliveryFx(): void {
        if (this._animState == 0) {
            // Spustit animaci
            this._animState = 1;
            this._animTime = TIMER.time;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._animState == 0)
            return;

        if (this._animState == 1) {
            this.updateState1();
        }
        else {
            this.updateState2();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateState1(): void {
        let progress = (TIMER.time - this._animTime) / 200;

        if (progress >= 1) {
            progress = 1;

            this._animState++;
            this._animTime = TIMER.time;
        }

        progress = pc.CubicOut(progress);
        this._vanEntity.setLocalScale(1, 1 + progress * DeliveryPoint.ANIM_SCALE_ADD, 1);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateState2(): void {
        let progress = (TIMER.time - this._animTime) / 200;

        if (progress >= 1) {
            progress = 1;
            this._animState = 0;
        }

        progress = pc.CubicIn(progress);
        this._vanEntity.setLocalScale(1, 1 + DeliveryPoint.ANIM_SCALE_ADD - progress * DeliveryPoint.ANIM_SCALE_ADD, 1);
    }
}